import React from 'react'
import { Button, Select } from 'components/Form'
// import { HiOutlineRefresh } from 'react-icons/hi'

/**
 * Page header component with title, company info, and action buttons
 * @param {Object} props - Component props
 */
const PageHeader = ({
    id,
    selectedCompany,
    globalCompany,
    xeroConfigs,
    xeroConfig,
    syncing,
    handleConfigChange,
    handleSyncAllData,
    handleRefreshConfig,
    handleRefreshData,
    onBack,
}) => {
    return (
        <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    {id ? 'Edit Invoice' : 'Create Invoice'}
                </h2>

                {/* Company info - show which company is being used */}
                {selectedCompany && (
                    <div className="mt-2 text-sm text-gray-600">
                        Company: <span className="font-medium">{selectedCompany.name}</span>
                        {/* Info tooltip about using navbar to change company */}
                        <span className="ml-2 text-xs text-blue-600">(Use company selector in top navbar to change)</span>
                    </div>
                )}

                {/* Xero Configuration Selector (only show if company selected and multiple configs) */}
                {selectedCompany && xeroConfigs && xeroConfigs.length > 1 && (
                    <div className="mt-2">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Select Xero Configuration
                        </label>
                        <Select value={xeroConfig?.id || ''} onChange={handleConfigChange} className="w-80">
                            <option value="">Select Configuration...</option>
                            {xeroConfigs.map(config => (
                                <option key={config.id} value={config.id}>
                                    {config.customer ? `${config.customer.customer_code}` : 'Default'}
                                    {config.is_test_mode ? ' (Test)' : ''}
                                </option>
                            ))}
                        </Select>
                    </div>
                )}

                {/* Show company and configuration status */}
                <div className="mt-2 text-sm">
                    {selectedCompany || globalCompany ? (
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-4">
                                <span className="text-green-600">✓ Company: {selectedCompany?.name || globalCompany?.name}</span>
                                {(xeroConfig && xeroConfig.tenant_id && !xeroConfig.is_token_expired) || (id && xeroConfig) ? (
                                    <span className="text-green-600">✓ Xero Connected</span>
                                ) : (
                                    <span className="text-yellow-600">⚠ No Xero Configuration</span>
                                )}
                                {xeroConfig && (!xeroConfig.tenant_id || xeroConfig.is_token_expired) && (
                                    <a
                                        href="/company-management/xero-integration"
                                        className="text-blue-600 hover:text-blue-800 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        → Fix Authorization
                                    </a>
                                )}
                            </div>
                            <div className="text-xs text-gray-500">
                                {xeroConfig
                                    ? 'Required permissions: accounting.contacts, accounting.transactions, accounting.settings'
                                    : 'Please set up Xero integration for this company'}
                            </div>
                        </div>
                    ) : (
                        <span className="text-red-600">⚠ Please select a company</span>
                    )}
                </div>
            </div>
            <div className="flex gap-2">
                <Button size="sm" variant="twoTone" onClick={onBack}>
                    Back to List
                </Button>
            </div>
        </div>
    )
}

export default PageHeader
